"use client";

import { c as _c } from "react/compiler-runtime";
import { useDashboardRouter as useRouter } from "@/hooks/useDashboardRouter";
import { useEffect, useMemo, useRef } from "react";
import { useActiveGithubOrgForUser, useConnectedGithubOrgs } from "@/hooks/useConnectedGithubOrgs";
import WelcomeDialog from "@/components/WelcomeDialog";
import { Dv360FloodlightAppLpConversion } from "@/components/marketing/Dv360FloodlightAppLpConversion";
import { useDashboardSearchParams as useSearchParams } from "@/hooks/useDashboardNavigation";
export default function Index() {
  const $ = _c(13);
  const router = useRouter();
  const nullableSearchParams = useSearchParams();
  let t0;
  if ($[0] !== nullableSearchParams) {
    t0 = nullableSearchParams ?? new URLSearchParams();
    $[0] = nullableSearchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const searchParams = t0;
  const {
    activeGithubOrg,
    codesmithEnabled
  } = useActiveGithubOrgForUser();
  const {
    connectedGithubOrgs
  } = useConnectedGithubOrgs();
  const hasNavigated = useRef(false);
  let t1;
  let t2;
  if ($[2] !== activeGithubOrg || $[3] !== codesmithEnabled || $[4] !== router || $[5] !== searchParams) {
    t1 = () => {
      if (activeGithubOrg && !hasNavigated.current) {
        hasNavigated.current = true;
        const params = new URLSearchParams(searchParams.toString());
        const landing = params.get("landing");
        params.delete("landing");
        const queryString = params.toString();
        const isMobile = window.matchMedia("(max-width: 767px)").matches;
        const basePath = codesmithEnabled ? landing === "codesmith" ? `/${activeGithubOrg}/sessions` : isMobile ? `/${activeGithubOrg}/sessions/new` : `/${activeGithubOrg}/runs/jobs` : `/${activeGithubOrg}/runs/jobs`;
        const newPath = `${basePath}${queryString ? `?${queryString}` : ""}`;
        router.replace(newPath, undefined, {
          shallow: true
        });
      }
    };
    t2 = [activeGithubOrg, codesmithEnabled, router, searchParams];
    $[2] = activeGithubOrg;
    $[3] = codesmithEnabled;
    $[4] = router;
    $[5] = searchParams;
    $[6] = t1;
    $[7] = t2;
  } else {
    t1 = $[6];
    t2 = $[7];
  }
  useEffect(t1, t2);
  let t3;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Dv360FloodlightAppLpConversion />;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== connectedGithubOrgs?.installations.length) {
    t4 = connectedGithubOrgs?.installations.length ? null : <WelcomeDialog />;
    $[9] = connectedGithubOrgs?.installations.length;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t4) {
    t5 = <>{t3}<div className="flex items-center justify-center h-64"><div className="text-center">{t4}</div></div></>;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}